import { render, staticRenderFns } from "./TheSettings.vue?vue&type=template&id=5955c3db&scoped=true&"
import script from "./TheSettings.vue?vue&type=script&lang=js&"
export * from "./TheSettings.vue?vue&type=script&lang=js&"
import style0 from "./TheSettings.vue?vue&type=style&index=0&id=5955c3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955c3db",
  null
  
)

export default component.exports